import styled from 'styled-components'

interface Props {
  model: 'primary' | 'secondary'
}

export const Buttons = styled.button<Props>`
  width: 267px;
  height: 54px;
  border-radius: 5px;

  span {
    color: #ffffff;
    font-family: proxima-nova;
    font-size: 18px;
    font-weight: bold;
    font-stretch: normal;
    font-style: normal;
    line-height: 1.22;
    letter-spacing: normal;
    text-align: center;
  }

  input[type='file'] {
    cursor: inherit;
    opacity: 0;
    position: relative;
    left: 0;
    width: inherit;
    height: inherit;
    top: -20px;
  }

  span.primary {
    background-color: #ff7b72;
  }

  span.secondary {
    color: #ff7b72;
    background-color: #ffffff;
  }

  background-color: ${({ model }: Props) =>
    model === 'primary' ? '#ff7b72' : '#ffffff'};
  border: solid 1px #ff7b72;
`
